import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitFinancingRedistributionBySourceLite = class PitFinancingRedistributionBySourceLite {
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySourceLite.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "year", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySourceLite.prototype, "_year", void 0);
tslib_1.__decorate([
    jsonMember({ name: "redistributionSum", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySourceLite.prototype, "redistributionSum", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingItemId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySourceLite.prototype, "financingItemId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingItemSrcId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySourceLite.prototype, "financingItemSrcId", void 0);
PitFinancingRedistributionBySourceLite = tslib_1.__decorate([
    jsonObject
], PitFinancingRedistributionBySourceLite);
export { PitFinancingRedistributionBySourceLite };
